import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { DynamicModule, InputsType } from 'ng-dynamic-component';

import { ColumnsComponent } from '@valk-nx/storyblok/components/columns/src/lib/columns';
import { HeadingGroupSectionComponent } from '@valk-nx/storyblok/components/heading-group-section/src/lib/heading-group-section';
import { RunningHeadComponent } from '@valk-nx/storyblok/components/running-head/src/lib/running-head';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import {
	BackgroundColors,
	ISbStoryBlok,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.types';

const Components = {
	columnOne: ColumnsComponent,
	columnThree: ColumnsComponent,
	columnTwo: ColumnsComponent,
	headingGroupSection: HeadingGroupSectionComponent,
	runningHead: RunningHeadComponent,
};

@Component({
	selector: 'sb-section',
	templateUrl: './section.html',
	imports: [CommonModule, DynamicModule, StoryblokDirective],
})
export class SectionComponent extends StoryblokRootDirective {
	@Input() sectionHeading: ISbStoryBlok[] | undefined;
	@Input() columns!: ISbStoryBlok[];
	@Input() sectionColor: BackgroundColors = 'white';

	components: typeof Components = Components;

	get titleInput(): (InputsType & { component: string })[] {
		if (typeof this.sectionHeading !== 'string') {
			return (
				this.sectionHeading?.map((blok) => ({
					...blok,
					component: blok['component'] ?? '',
					maxWidth: 'max-w-screen-xl',
				})) || []
			);
		}
		return [];
	}

	get columnsInput(): (InputsType & { component: string })[] {
		return this.columns.map((blok) => ({
			...blok,
			component: blok['component'] ?? '',
		}));
	}

	constructor() {
		super();
	}
}
